import { cn } from "@util/helpers";

type CardBlurbProps = {
  className?: string;
  blurb?: string;
};

const CardBlurb = ({
  className,
  blurb,
}: CardBlurbProps): React.ReactElement => {
  return (
    <p
      data-testid="card-blurb-component"
      className={cn("typo-card-blurb hidden lg:block", className)}
    >
      {blurb}
    </p>
  );
};

export default CardBlurb;
